<template>
  <NuxtLink :to="link" class="articles-card">
    <div class="body">
      <img v-if="card.image" :src="card.image" :alt="card.name" loading="lazy" />
    </div>

    <div class="header">
      <h3 class="title">{{ card.name }}</h3>
    </div>

    <div class="footer">
      <div class="field">
        <BaseIconSvoi icon="time/calendar" size="s" />
        <span>{{ formattedDate }}</span>
      </div>
    </div>
  </NuxtLink>
</template>

<script lang="ts" setup>
  import { BaseIconSvoi } from '~/components/base-ui/icon'
  import type { ArticleMainItem } from '~/models/articles'
  import { toMonthYearDateFormat } from '~/shared/utils/date'

  const props = defineProps<{
    card: ArticleMainItem
  }>()

  const link = computed(() => props.card.link || `/news/${props.card.slug}`)

  const formattedDate = computed(() => {
    const value = props.card.publicationDate
    return value ? toMonthYearDateFormat(value) : ''
  })
</script>

<style lang="scss" scoped>
  .articles-card {
    @extend %flex-column;

    height: 100%;
    gap: 20px;
    padding: 24px 20px;
    border-radius: 24px;
    background-color: $color-default-white;
    text-decoration: none;
    color: inherit;

    > .body {
      overflow: hidden;
      height: 240px;
      border-radius: 20px;

      @include vp-1279 {
        height: 180px;
      }

      > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    > .header {
      @extend %flex-column;

      gap: 12px;

      > .title {
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-size: 20px;
        font-weight: 600;
        line-height: 28px;

        @include vp-1279 {
          font-size: 18px;
          line-height: 26px;
        }
      }
    }

    > .footer {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-top: auto;

      > .field {
        display: flex;
        align-items: center;
        gap: 8px;
        color: $color-potato-30;

        > span {
          font-size: 14px;
          font-weight: 600;
          line-height: 22px;
          color: $color-potato-60;
        }
      }
    }
  }
</style>
